module.exports = __webpack_public_path__ + "static/media/itravel.c5cb0fb2.svg";